export type AssessmentDraft = {
  assessmentResultId?: string;
  engineVersion?: string;
  engineSnapshot?: {
    dimensions?: Record<string, number>;
    archetypeScores?: Record<string, number>;
    shapeBias?: Record<string, number>;
    selectedArchetype?: string;
    selectedDomain?: string;
    congruence?: number;
    confidence?: number;
    pathDistribution?: Array<{ label: string; pct: number }>;
  };
  saveToAccount?: boolean;
  archetype?: string;
  archetypeName?: string;
  domain?: string;
  domainName?: string;
  topPath?: string;
  category?: string;
  createdAt?: string;
  locale?: 'en' | 'it';
  answers?: {
    visual?: Record<string, unknown>;
    identity?: Record<string, unknown>;
    interests?: Record<string, unknown>;
    context?: Record<string, unknown>;
    freeText?: string;
  };
  [key: string]: unknown;
};

export function isCompleteAssessmentDraft(
  draft: AssessmentDraft | null
): draft is AssessmentDraft {
  return Boolean(
    draft?.assessmentResultId &&
      draft.archetype &&
      draft.domain &&
      draft.topPath &&
      draft.answers &&
      typeof draft.answers === 'object'
  );
}

function assessmentTime(value?: string) {
  if (!value) return 0;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function isAssessmentDraftNewer(
  draft: AssessmentDraft | null,
  existing?: AssessmentDraft
) {
  if (!isCompleteAssessmentDraft(draft)) return false;
  if (!existing) return true;
  if (
    draft.saveToAccount === true &&
    draft.assessmentResultId !== existing.assessmentResultId
  ) {
    return true;
  }
  const draftTime = assessmentTime(draft.createdAt);
  const existingTime = assessmentTime(existing.createdAt);

  // IDs establish identity, not recency. An older tab can retain a complete
  // draft with a different ID; treating every different ID as newer lets that
  // stale tab overwrite a recently completed retake.
  if (draftTime || existingTime) return draftTime > existingTime;
  return Boolean(
    draft.assessmentResultId &&
    draft.assessmentResultId !== existing.assessmentResultId
  );
}
